import { createPersistentComponentState } from '@/state';
import { customLocalStorage } from '@/state/storage';

const initGlobalState: {
  hotkeys: Record<string, { name: string; description: string; source: string }>;
} = {
  hotkeys: {},
};
const useGlobalState = createPersistentComponentState('globalState', initGlobalState, {
  storage: customLocalStorage,
});

export default useGlobalState;
